import React, { useState, useCallback, useEffect, useMemo } from 'react';
import GoogleMapComp from '../../components/GoogleMap';
import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import { io } from 'socket.io-client';
import ApiCaller from '../../config/api';

const GRAY_MARKER =
    'data:image/svg+xml;charset=UTF-8,' +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="27" height="43" viewBox="0 0 27 43"><path fill="#A0A0A0" stroke="#555555" stroke-width="1" d="M13.5 0C6.04 0 0 6.04 0 13.5 0 23.63 13.5 43 13.5 43S27 23.63 27 13.5C27 6.04 20.96 0 13.5 0z"/><circle fill="#FFFFFF" cx="13.5" cy="13.5" r="5"/></svg>',
    );

const getMarkerIcon = (guard) => {
    if (!guard.isOnline) return GRAY_MARKER;

    switch (guard.attendanceStatus) {
        case 'checkedIn':
            return 'http://maps.google.com/mapfiles/ms/icons/green.png';
        case 'checkedOut':
            return 'http://maps.google.com/mapfiles/ms/icons/red.png';
        case 'notCheckedIn':
            return 'http://maps.google.com/mapfiles/ms/icons/yellow.png';
        case 'noShift':
            return 'http://maps.google.com/mapfiles/ms/icons/blue.png';
        default:
            return 'http://maps.google.com/mapfiles/ms/icons/blue.png';
    }
};

const LiveTracking = ({ selectedUser, markersMap, setSelectedUser }) => {
    // Convert markers map to array for GoogleMapComp
    const pointerPosition = useMemo(() => {
        return Object.values(markersMap).map((guard) => ({
            lat: parseFloat(guard.currentLocation.latitude),
            lng: parseFloat(guard.currentLocation.longitude),
            icon: getMarkerIcon(guard),
            ...guard,
        }));
    }, [markersMap]);

    const handlePointerClick = useCallback((user) => {
        setSelectedUser(user);
    }, []);

    return (
        <div className="w-full h-[500px]">
            <GoogleMapComp
                pointerPosition={pointerPosition}
                onPointerClick={handlePointerClick}
            />

            {selectedUser && (
                <Modal
                    title={`${selectedUser.firstName || ''} ${selectedUser.lastName || ''}`}
                    open={selectedUser !== null}
                    onCancel={() => setSelectedUser(null)}
                    footer={null}
                    width={400}
                >
                    <div style={{ padding: '10px 0' }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                marginBottom: 16,
                            }}
                        >
                            {selectedUser.imageUrl ? (
                                <img
                                    src={selectedUser.imageUrl}
                                    alt="Profile"
                                    style={{
                                        width: 60,
                                        height: 60,
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                    }}
                                />
                            ) : (
                                <div
                                    style={{
                                        width: 60,
                                        height: 60,
                                        borderRadius: '50%',
                                        background: '#eee',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    👤
                                </div>
                            )}
                            <div>
                                <h3 style={{ margin: 0, fontSize: 16 }}>
                                    {selectedUser.firstName}{' '}
                                    {selectedUser.lastName}
                                </h3>
                                <p
                                    style={{
                                        margin: 0,
                                        color: '#666',
                                        fontSize: 13,
                                    }}
                                >
                                    {selectedUser.role || 'Guard'}
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8,
                                fontSize: 14,
                            }}
                        >
                            <div>
                                <span style={{ fontWeight: 600 }}>Status:</span>{' '}
                                <span
                                    style={{
                                        color: selectedUser.isOnline
                                            ? '#389e0d'
                                            : '#888',
                                        fontWeight: 500,
                                    }}
                                >
                                    {selectedUser.isOnline
                                        ? '🟢 Online'
                                        : '⚪ Offline'}
                                </span>
                            </div>
                            <div>
                                <span style={{ fontWeight: 600 }}>
                                    Attendance:
                                </span>{' '}
                                <span style={{ textTransform: 'capitalize' }}>
                                    {selectedUser.attendanceStatus || 'N/A'}
                                </span>
                            </div>
                            {selectedUser.shift?.property && (
                                <div>
                                    <span style={{ fontWeight: 600 }}>
                                        Property:
                                    </span>{' '}
                                    {selectedUser.shift.property.name || 'N/A'}
                                </div>
                            )}
                            {selectedUser.lastSeenAt && (
                                <div>
                                    <span style={{ fontWeight: 600 }}>
                                        Last Seen:
                                    </span>{' '}
                                    {new Date(
                                        selectedUser.lastSeenAt,
                                    ).toLocaleString()}
                                </div>
                            )}
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default LiveTracking;
